export class Answer {
    constructor(answer) {
        this.id          = answer.id;
        this.content     = answer.content;
        // this.created_at  = answer.created_at;
        this.status      = answer.status;
        this.system      = answer.system;
        this.type        = answer.type;
        // this.updated_at  = answer.updated_at;/
        this.show_status = answer.show_status ? answer.show_status : 1; //0: deleted, 1: not update, 2: updated, 3: new added
    }
    changeShowStatus(show_status) {
        this.show_status = show_status;
    }

    updateContent(content) {
        this.content = content;
    }
}